import React from 'react';
import { Container, Menu } from 'semantic';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NavigationMenu() {
  const { t } = useTranslation();

  return (
    <Container>
      <Menu pointing secondary>
        <Menu.Item
          as={NavLink}
          to="/charging-stations/policies-and-groups/charging-policies"
          exact
          name={t(
            'policiesAndGroups.menu.chargingPolicies',
            'Charging Policies'
          )}
        />
        <Menu.Item
          exact
          as={NavLink}
          to="/charging-stations/policies-and-groups/customer-groups"
          name={t('policiesAndGroups.menu.customerGroups', 'Customer Groups')}
        />
        <Menu.Item
          exact
          as={NavLink}
          to="/charging-stations/policies-and-groups/charging-groups"
          name={t('policiesAndGroups.menu.chargingGroups', 'Charging Groups')}
        />
      </Menu>
    </Container>
  );
}
